"use client";

import { useEffect } from "react";

import ErrorBlock from "@/components/molecules/ErrorBlock";
import { usePathnameLocale } from "@/hooks/usePathnameLocale";

interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

const ErrorPage = ({ error, reset }: ErrorPageProps) => {
  useEffect(() => {
    if (error?.name === "ChunkLoadError") {
      window.location.reload();
      return;
    }

    console.error(error);
  }, [error]);

  const locale = usePathnameLocale();

  return (
    <main className="grid place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <ErrorBlock locale={locale} error={error} reset={reset} />
    </main>
  );
};

export default ErrorPage;
